/* Treasure Vault — product variant state */
(function(){
  'use strict';
  if(!window.Vault) return;
  var V = window.Vault;

  var productScript = document.querySelector('script[id^="product-json-"]');
  if(!productScript) return;
  var product;
  try { product = JSON.parse(productScript.textContent); } catch(e){ return; }
  if(!product || !product.variants) return;

  var form = V.$('.product-form');
  if(!form) return;

  function getSelectedOptions(){
    var byOption = {};
    V.$$('[data-variant-pill]', form).forEach(function(pill){
      if(pill.classList.contains('is-selected')) byOption[pill.getAttribute('data-option-index')] = pill.getAttribute('data-value');
    });
    var opts = [];
    for(var i = 0; i < product.options.length; i++) opts.push(byOption[i] || null);
    return opts;
  }

  function findVariant(opts){
    return product.variants.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); });
  }

  function finiteInventory(variant){
    return !!variant && variant.available === true &&
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy === 'deny' &&
      typeof variant.inventory_quantity === 'number' &&
      variant.inventory_quantity > 0;
  }

  function updatePillAvailability(){
    var selected = getSelectedOptions();
    V.$$('[data-variant-pill]', form).forEach(function(pill){
      var optIdx = parseInt(pill.getAttribute('data-option-index'), 10);
      if(isNaN(optIdx)) return;
      var candidate = selected.slice();
      candidate[optIdx] = pill.getAttribute('data-value');
      var match = product.variants.find(function(v){
        return v.options.every(function(o,i){
          if(i === optIdx) return o === candidate[optIdx];
          if(candidate[i] == null) return true;
          return o === candidate[i];
        });
      });
      var unavailable = !match || match.available === false;
      var selectedNow = pill.classList.contains('is-selected');
      pill.classList.toggle('is-unavailable', unavailable);
      pill.setAttribute('aria-pressed', selectedNow ? 'true' : 'false');
      pill.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
    });
  }

  function syncQuantity(variant){
    var qty = V.$('[data-qty-input]', form);
    if(!qty) return;
    if(finiteInventory(variant)){
      qty.setAttribute('max', String(variant.inventory_quantity));
      var current = parseInt(qty.value, 10);
      if(isNaN(current) || current < 1) current = 1;
      if(current > variant.inventory_quantity) current = variant.inventory_quantity;
      qty.value = String(current);
    } else {
      qty.removeAttribute('max');
    }
  }

  function syncAvailabilityControls(variant){
    var available = !!(variant && variant.available);
    var notify = V.$('[data-notify-me]');
    if(notify){
      notify.hidden = available;
      if(variant) notify.setAttribute('data-variant-id', String(variant.id));
    }
    var buyNow = V.$('.product-buy-now');
    if(buyNow) buyNow.hidden = !available;
  }

  function updateUI(variant){
    var atc = V.$('[data-atc]');
    var atcText = V.$('[data-atc-text]');
    if(!variant){
      if(atc) atc.disabled = true;
      if(atcText) atcText.textContent = 'Unavailable';
      syncAvailabilityControls(null);
      return;
    }

    var idIn = V.$('[data-variant-id]');
    if(idIn) idIn.value = variant.id;
    var price = V.$('[data-price]');
    if(price) price.textContent = V.formatMoney(variant.price);
    var compare = V.$('[data-compare]');
    var save = V.$('[data-save]');

    if(variant.compare_at_price && variant.compare_at_price > variant.price){
      if(compare){ compare.textContent = V.formatMoney(variant.compare_at_price); compare.style.display = ''; }
      if(save){
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        save.textContent = 'Save ' + V.formatMoney(variant.compare_at_price - variant.price) + ' (' + pct + '%)';
        save.style.display = '';
      }
    } else {
      if(compare) compare.style.display = 'none';
      if(save) save.style.display = 'none';
    }

    var qtyWrap = V.$('[data-qty-wrap]');
    var qtyRow = V.$('.product-qty-row');
    if(qtyWrap) qtyWrap.hidden = !variant.available;
    if(qtyRow) qtyRow.classList.toggle('product-qty-row--unavailable', !variant.available);
    syncQuantity(variant);
    syncAvailabilityControls(variant);

    var stockWrap = V.$('[data-stock-wrapper]');
    var isPreorder = stockWrap && stockWrap.getAttribute('data-is-preorder') === 'true';
    if(stockWrap){
      var pillClass, label;
      if(isPreorder && variant.available){
        pillClass = 'stock-pill--preorder'; label = 'Available to pre-order';
      } else if(variant.available){
        var cfg = (window.VAULT && window.VAULT.settings) || {};
        var isLow = cfg.lowStockEnabled === true && (cfg.lowStockThreshold || 0) > 0 && finiteInventory(variant) && variant.inventory_quantity <= cfg.lowStockThreshold;
        if(isLow){ pillClass = 'stock-pill--low'; label = 'Low stock · ' + variant.inventory_quantity + ' left'; }
        else { pillClass = 'stock-pill--in'; label = 'In stock'; }
      } else {
        pillClass = 'stock-pill--out'; label = 'Sold out';
      }
      var span = document.createElement('span');
      span.className = 'stock-pill ' + pillClass;
      var dot = document.createElement('span');
      dot.className = 'stock-pill__dot';
      span.appendChild(dot);
      span.appendChild(document.createTextNode(label));
      stockWrap.replaceChildren(span);
    }

    if(atc) atc.disabled = !variant.available;
    if(atcText) atcText.textContent = variant.available ? (isPreorder ? 'Pre-order · ' : 'Add to cart · ') + V.formatMoney(variant.price) : 'Sold out';

    var stickyPrice = V.$('[data-sticky-price]');
    if(stickyPrice) stickyPrice.textContent = V.formatMoney(variant.price);
    var stickyCompare = V.$('[data-sticky-compare]');
    if(stickyCompare){
      if(variant.compare_at_price && variant.compare_at_price > variant.price){ stickyCompare.textContent = V.formatMoney(variant.compare_at_price); stickyCompare.style.display = ''; }
      else stickyCompare.style.display = 'none';
    }
    var stickyStock = V.$('[data-sticky-stock]');
    if(stickyStock) stickyStock.style.display = variant.available ? '' : 'none';
    var stickyBtn = V.$('[data-sticky-atc-btn]');
    var stickyText = V.$('[data-sticky-atc-text]');
    if(stickyBtn) stickyBtn.disabled = !variant.available;
    if(stickyText) stickyText.textContent = variant.available ? (isPreorder ? 'Pre-order · ' : 'Add to cart · ') + V.formatMoney(variant.price) : 'Sold out';

    if(variant.featured_media){
      var slides = V.$$('[data-gallery-slides] [data-media-id]');
      var idx = slides.findIndex(function(s){ return s.getAttribute('data-media-id') == variant.featured_media.id; });
      if(idx >= 0){
        slides.forEach(function(s,i){ s.classList.toggle('is-active', i === idx); });
        V.$$('[data-thumb]').forEach(function(t,i){ t.classList.toggle('is-active', i === idx); });
        var current = V.$('[data-gallery-current]');
        if(current) current.textContent = (idx + 1);
      }
    }

    var paymentZone = V.$('[data-payment-zone]');
    if(paymentZone) paymentZone.setAttribute('data-amount', variant.price);
    document.dispatchEvent(new CustomEvent('variant:changed', {detail:{variant:variant, price:variant.price}}));
    if(window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function'){
      try { window.Klarna.OnsiteMessaging.refresh(); } catch(e){}
    }
    if(window.Afterpay && typeof window.Afterpay.redraw === 'function'){
      try { window.Afterpay.redraw(); } catch(e){}
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e){}
  }

  function onPillClick(e){
    var pill = e.target.closest('[data-variant-pill]');
    if(!pill || pill.getAttribute('aria-disabled') === 'true') return;
    var optIdx = pill.getAttribute('data-option-index');
    V.$$('[data-variant-pill][data-option-index="' + optIdx + '"]', form).forEach(function(p){
      p.classList.remove('is-selected');
      p.setAttribute('aria-pressed','false');
    });
    pill.classList.add('is-selected');
    pill.setAttribute('aria-pressed','true');
    var display = V.$('[data-option-display="' + optIdx + '"]');
    if(display) display.textContent = pill.getAttribute('data-value');
    updateUI(findVariant(getSelectedOptions()));
    updatePillAvailability();
  }

  form.addEventListener('click', onPillClick);
  var initialId = V.$('[data-variant-id]', form);
  if(initialId){
    var initial = product.variants.find(function(v){ return String(v.id) === String(initialId.value); });
    if(initial) updateUI(initial);
  }
  updatePillAvailability();
})();
